import "./TechnicalInsights.module.css";
import Header from "@/reusable_sections/Header";
import TechnicalPostArchive from "./sections/TechnicalPostArchive";
import Footer from "@/reusable_sections/Footer";
export default function TechnicalInsightsPage() {
  return <div>
      <Header />
      <TechnicalPostArchive />
      <Footer />
    </div>;
}